"use client";

import { useEffect, useRef } from "react";
import gsap from "gsap";
import { Draggable } from "gsap/Draggable";
import { useGSAP } from "@gsap/react";

gsap.registerPlugin(Draggable);

export default function TeamCarousel() {
  const containerRef = useRef(null);

  const images = [
    {
      src: "/image/muhammadhilman.jpg",
      name: "Muhammad Hilman",
      alt: "Muhammad Hilman",
      link: "https://www.linkedin.com/in/muhammadhilman/"
    },
    {
      src: "/image/muhammadhilman.jpg",
      name: "Muhammad Hilman",
      alt: "Muhammad Hilman",
      link: "https://www.linkedin.com/in/muhammadhilman/"
    },
    {
      src: "/image/muhammadhilman.jpg",
      name: "Muhammad Hilman",
      alt: "Muhammad Hilman",
      link: "https://www.linkedin.com/in/muhammadhilman/"
    },
    {
      src: "/image/muhammadhilman.jpg",
      name: "Muhammad Hilman",
      alt: "Muhammad Hilman",
      link: "https://www.linkedin.com/in/muhammadhilman/"
    },
    {
      src: "/image/muhammadhilman.jpg",
      name: "Muhammad Hilman",
      alt: "Muhammad Hilman",
      link: "https://www.linkedin.com/in/muhammadhilman/"
    },
    {
      src: "/image/muhammadhilman.jpg",
      name: "Muhammad Hilman",
      alt: "Muhammad Hilman",
      link: "https://www.linkedin.com/in/muhammadhilman/"
    }
  ];
  useGSAP(
    () => {
      const container = containerRef.current;
      const cards = gsap.utils.toArray(".card");
      const radius = 360; // jarak dari pusat
      const step = 360 / cards.length; // sudut tiap kartu

      // Posisi awal kartu dalam lingkaran
      cards.forEach((card, i) => {
        const angle = i * step;
        const rad = (angle * Math.PI) / 180;
        gsap.set(card, {
          //   rotation: angle,
          x: Math.cos(rad) * radius,
          y: Math.sin(rad) * radius
        });
      });

      // Draggable untuk memutar container
      Draggable.create(container, {
        type: "rotation",
        inertia: true,
        onPress() {
          // hilangkan blur dulu
          gsap.to(cards, { filter: "blur(0px)", duration: 0.2 });
        },
        onDrag() {
          gsap.to(cards, {
            x: (i) => Math.cos(((i * step + this.rotation) * Math.PI) / 180) * radius,
            y: (i) => Math.sin(((i * step + this.rotation) * Math.PI) / 180) * radius,
            rotation: (i) => i * step + this.rotation,
            duration: 0.4, // smooth easing
            ease: "power3.out",
            filter: "blur(4px)" // blur saat drag
          });
        },
        onRelease() {
          gsap.to(cards, {
            filter: "blur(0px)", // kembali tajam
            duration: 0.5,
            ease: "power2.out"
          });
        },
        onThrowUpdate: function () {
          gsap.to(cards, {
            x: (i) => Math.cos(((i * step + this.rotation) * Math.PI) / 180) * radius,
            y: (i) => Math.sin(((i * step + this.rotation) * Math.PI) / 180) * radius,
            rotation: (i) => i * step + this.rotation,
            duration: 0.4,
            ease: "power3.out",
            filter: "blur(2px)" // inertia masih agak blur
          });
        }
      });
    },
    { scope: containerRef }
  );

  return (
    <div ref={containerRef} className='relative h-[600px] md:h-full flex items-center justify-center'>
      {images.map((image, index) => (
        <div key={index} className='card absolute w-52 h-86   rotate-90 flex items-center justify-start'>
          <div className='absolute text-red-500 z-50 rotate-90 translate-x-62'>{image.name}</div>
          <img src={image.src} alt={image.alt} className='w-full relative rotate-90 h-full object-cover rounded-xl ' />
        </div>
      ))}
    </div>
  );
}
